module.exports = __webpack_public_path__ + "img/04-3.e61ad4b3.png";